import { ChangeDetectorRef, Component, EventEmitter, Inject, Injector, Input, LOCALE_ID, OnInit, Optional, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { HttpService } from '@ecp-caf/caf-common';
import { MessagerService } from '@farris/ui-messager';
import { TypeConverter } from '@farris/ide-property-panel';
import { ProcessDesignerUIState } from '../../app/process-designer.uistate';
import { AssignConfig } from './assign-config';
import { AssignStrategy } from './assign-strategy';
import { WF_LANG_RESOURCES, WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { WF_PROCESS_EDITOR_LANG_RESOURCES } from '../../i18n/assets/lang.resource';

@Component({
  selector: 'lib-assign-strategy',
  templateUrl: './assign-strategy.component.html',
  styleUrls: ['./assign-strategy.component.css'],
  providers: [
     WfLocalePipe,
  ]
})
export class AssignStrategyComponent implements OnInit {

  @Output() closeModal = new EventEmitter<any>();
  @Output() submitModal = new EventEmitter<any>();

  @Input()
  set value(assignStrategy: AssignStrategy) {
    this.assignStrategy = assignStrategy || new AssignStrategy();
    if (!this.assignStrategy.assignConfig) {
      this.assignStrategy.assignConfig = new AssignConfig();
    }
    this.assingPerformerConfigForm.setValue({
      multiSelect: this.assignStrategy.assignConfig.multiSelect,
      necessary: this.assignStrategy.assignConfig.necessary
    });
  }

  @ViewChild('iconSelectFooter') modalFooter: TemplateRef<any>;

  assingPerformerConfigForm: FormGroup = new FormGroup({
    multiSelect: new FormControl(true),
    necessary: new FormControl(false)
  });

  assignStrategy = new AssignStrategy();
  assignStrategyList = [
    { value: 'ALL', name: this.localePipe.transform('component.assignStrategy.all') },
    { value: 'ASSIGN', name: this.localePipe.transform('component.assignStrategy.assign') },
    { value: 'CLAIM', name: this.localePipe.transform('component.assignStrategy.claim') }
  ];

  operatorCollection = [
    { text: this.localePipe.transform('component.assignStrategy.currentUser'), value: 'currentUser' },
    { text: this.localePipe.transform('component.assignStrategy.procInstCreator'), value: 'procInstCreator' }];

  modalConfig = {
    title: this.localePipe.transform('component.assignStrategy.assignStrategy'),
    width: 405,
    height: 350,
    showButtons: true
  };


  constructor(
    private injector: Injector,
    private message: MessagerService,
    private designerUIState: ProcessDesignerUIState,
    private http: HttpService,
    @Optional() private cdr: ChangeDetectorRef,
    @Inject(LOCALE_ID) private localeId: string,
    @Inject(WF_LANG_RESOURCES) private resources: any,
    @Optional() private localePipe: WfLocalePipe
  ) {
    this.localePipe = this.localePipe || new WfLocalePipe(localeId, resources);
   }

  ngOnInit() {
  }

  changeValue(event: any) {
    if (event === 'ASSIGN') {
      if (!this.assignStrategy.assignConfig) {
        this.assignStrategy.assignConfig = new AssignConfig();
      }
      this.assingPerformerConfigForm.setValue({
        multiSelect: this.assignStrategy.assignConfig.multiSelect,
        necessary: this.assignStrategy.assignConfig.necessary
      });
    }
  }

  clickOK() {
    this.assignStrategy.assignConfig.multiSelect = this.assingPerformerConfigForm.get('multiSelect').value;
    this.assignStrategy.assignConfig.necessary = this.assingPerformerConfigForm.get('necessary').value;
    console.log(this.assignStrategy);
    const object = { value: this.assignStrategy, parameters: null };
    this.submitModal.emit(object);
  }

  clickCancel() {
    this.closeModal.emit();
  }
}

export class AssignStrategyConverter implements TypeConverter {
  constructor(
    private localePipe: WfLocalePipe
  ) { }

  convertTo(data: AssignStrategy): string {
    switch (data.assignStrategy) {
      case 'ALL':
        return this.localePipe.transform('component.assignStrategy.all');
      case 'ASSIGN':
        return this.localePipe.transform('component.assignStrategy.assign');
      case 'CLAIM':
        return this.localePipe.transform('component.assignStrategy.claim');
      default:
        return '';
    }
  }
}

